module.exports = __webpack_public_path__ + "static/gond-symbol-DND3_FnP-e0466febb6a3b4464b78a264eda7ebd4.jpg";